<h1 mat-dialog-title *ngIf="data && data.title">{{data.title}}</h1>
<div mat-dialog-content *ngIf="data && data.message">
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <button *nfIf="data && data.hideCancel" mat-button (click)="onCancel()">{{'COMMON.CANCEL' | translate}}</button>
  <button mat-button (click)="onOK()" cdkFocusInitial>{{'COMMON.OK' | translate}}</button>
</div>
